// QUACK! This is a duck. https://github.com/erikras/ducks-modular-redux

// Actions
const UPDATE_ACCOUNT_FORM_STATE = 'UPDATE_ACCOUNT_FORM_STATE';
const UPDATE_PAYMENT_FORM_STATE = 'UPDATE_PAYMENT_FORM_STATE';

// Reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case UPDATE_ACCOUNT_FORM_STATE:
      return {
        ...state,
        [action.form]: action.payload
      }
    default:
      return state
  }
}

// Action Creators
export const updateFormState = (form, state) => {
  let actionType;
  if(form==='account') {
    actionType = UPDATE_ACCOUNT_FORM_STATE;
  } else if(form==='payment') {
    actionType = UPDATE_PAYMENT_FORM_STATE;
  }
  return({
    type: actionType,
    form,
    payload: state
  })
}

// Selectors
export const getFormState = (state, form) =>
  (state && state.form && state.form[form]) || {}



// WEBPACK FOOTER //
// ./src/components/Common/finalFormDuck.js